import React from 'react';
import { useGlobalContext } from '../../context/GlobalContext';
import { TOOL_ID } from '../../actions';
import AdminDashboard from './AdminDashboard';
import AdminDashboardSelector from './AdminDashboardSelector';
import MemberDashboard from './MemberDashboard/MemberDashboard';
import OwnerDashboardSelector from './OwnerDashboardSelector';

export default function Dashboard() {
  const [context] = useGlobalContext();
  const role = context.auth.userAuth?.tools?.find((t) => t.tool === TOOL_ID)?.role;

  if (role === 'Member') {
    return <MemberDashboard />;
  }

  if (role === 'Owner') {
    return <OwnerDashboardSelector />;
  }

  if (role === 'Admin') {
    return <AdminDashboardSelector />;
  }

  return <AdminDashboard />;
}
